import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        const res = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        setToken(res.data.token);
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.data.user.onboarding_done ? "/dashboard" : "/onboarding", { state: { user: res.data.user } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen hero-bg flex flex-col items-center justify-center gap-4">
      <Logo to={null} />
      <div className="h-8 w-8 rounded-full border-4 border-blue-200 border-t-brandblue animate-spin" />
      <p className="text-slate-500">{error || "Signing you in…"}</p>
    </div>
  );
}
